<ng-template #noticeLine>
  <p
    *ngIf="notice"
    class="m-0 text-sm"
    [ngClass]="notice.tone === 'error' ? 'text-status-red' : 'text-gray-700'"
    [attr.role]="notice.tone === 'error' ? 'alert' : 'status'"
  >
    {{ notice.key | translate: notice.params }}
  </p>
</ng-template>

<ng-container *ngIf="step === 'code'; else addressStep">
  <h1 class="m-0 text-2xl font-medium">
    {{ (isNewDevice ? 'Login.NewDeviceTitle' : 'Login.VerifyTitle') | translate }}
  </h1>
  <p class="m-0 text-gray-700">
    {{
      linkCode
        ? ('Login.CodeFilledIn' | translate)
        : ((isNewDevice ? 'Login.NewDeviceCodeSentTo' : 'Login.CodeSentTo')
          | translate: { address: sentTo })
    }}
  </p>
  <!-- No "remember this browser" choice: a completed check always trusts it, except for a super user. -->
  <p *ngIf="isNewDevice && challenge.trustDays" class="m-0 text-gray-700">
    {{ 'Login.NewDeviceTrust' | translate: { days: challenge.trustDays } }}
  </p>

  <form [formGroup]="codeForm" (ngSubmit)="verify()" class="flex flex-col gap-1">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Login.Code' | translate }}</mat-label>
      <input
        #firstField
        matInput
        id="verification-code"
        formControlName="code"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="7"
      />
    </mat-form-field>
    <ng-container *ngTemplateOutlet="noticeLine"></ng-container>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      class="mt-2 h-12 w-full"
      [disabled]="busy || !codeIsComplete"
      [attr.aria-busy]="busy"
    >
      {{ (busy ? 'Login.Verifying' : 'Login.Verify') | translate }}
    </button>
  </form>

  <div class="flex flex-wrap justify-center gap-2">
    <button
      *ngIf="!linkCode"
      mat-button
      color="primary"
      type="button"
      [disabled]="busy || resendPaused || sendLimitReached"
      (click)="resend()"
    >
      {{ 'Login.ResendCode' | translate }}
    </button>
    <button
      *ngIf="enteredAddress; else backButton"
      mat-button
      color="primary"
      type="button"
      (click)="useDifferentAddress()"
    >
      {{ 'Login.UseDifferentAddress' | translate }}
    </button>
  </div>

  <p *ngIf="!linkCode && !enteredAddress" class="m-0 text-center text-sm text-gray-600">
    {{ 'Login.AddressNotYours' | translate }}
  </p>
</ng-container>

<ng-template #addressStep>
  <h1 class="m-0 text-2xl font-medium">{{ 'Login.AddressTitle' | translate }}</h1>
  <p class="m-0 text-gray-700">{{ 'Login.AddressIntro' | translate }}</p>

  <form [formGroup]="addressForm" (ngSubmit)="submitAddress()" class="flex flex-col gap-1">
    <mat-form-field appearance="outline" hideRequiredMarker>
      <mat-label>{{ 'Login.EmailAddress' | translate }}</mat-label>
      <input
        #firstField
        matInput
        id="verification-address"
        formControlName="emailAddress"
        type="email"
        autocomplete="email"
      />
    </mat-form-field>
    <ng-container *ngTemplateOutlet="noticeLine"></ng-container>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      class="mt-2 h-12 w-full"
      [disabled]="busy || addressForm.invalid || sendLimitReached"
      [attr.aria-busy]="busy"
    >
      {{ (busy ? 'Login.SendingCode' : 'Login.SendCode') | translate }}
    </button>
  </form>

  <div class="flex justify-center">
    <ng-container *ngTemplateOutlet="backButton"></ng-container>
  </div>
</ng-template>

<ng-template #backButton>
  <button mat-button color="primary" type="button" (click)="back()">
    {{ 'Login.BackToSignIn' | translate }}
  </button>
</ng-template>
